import { cva } from '@/styled-system/css';

export const filterChipRootRecipe = cva({
  base: {
    display: 'inline-flex',
    position: 'relative',
    alignItems: 'center',
    boxShadow: {
      base: 'inset 0 0 0 {borderWidths.Chip.default} var(--shadow-color)',
      _focusVisible: 'inset 0 0 0 {borderWidths.Chip.default} var(--shadow-color), {shadows.focus}',
    },
    boxShadowColor: { base: 'Chip.border.default' },
    borderRadius: 'Chip',
    paddingInline: 'Chip.padding.horz',
    paddingBlock: 'Chip.padding.vert',
    backgroundColor: { base: 'Chip.bg.default' },
    transition: {
      _motionReduce: 'none',
      _motionSafe: 'box-shadow 200ms ease, background-color 200ms ease',
    },
    minWidth: '0',
  },
  variants: {
    disabled: {
      true: {
        opacity: 'disabled',
        cursor: 'default',
      },
      false: {
        cursor: 'pointer',
        backgroundColor: {
          _hover: 'Chip.bg.hover',
          _active: 'Chip.bg.pressed',
        },
        boxShadowColor: {
          _hover: 'Chip.border.hover',
          _active: 'Chip.border.pressed',
        },
        _after: {
          content: '""',
          position: 'absolute',
          height: 'Chip.tapArea',
          minWidth: 'Chip.tapArea',
          width: '100%',
          left: '0',
          top: '50%',
          marginTop: 'calc(({sizes.Chip.tapArea} / 2) * -1)',
        },
      },
    },
    elevated: {
      true: {
        backgroundColor: { base: 'Chip.bg.elevated.default' },
      },
      false: {},
    },
    selected: {
      true: {
        boxShadow: {
          base: 'inset 0 0 0 {borderWidths.Chip.selected} var(--shadow-color)',
          _focusVisible:
            'inset 0 0 0 {borderWidths.Chip.selected} var(--shadow-color), {shadows.focus}',
        },
      },
      false: {},
    },
  },
  compoundVariants: [
    {
      disabled: false,
      elevated: true,
      css: {
        backgroundColor: {
          _hover: 'Chip.bg.elevated.hover',
          _active: 'Chip.bg.elevated.pressed',
        },
      },
    },
    {
      disabled: true,
      selected: true,
      css: {
        backgroundColor: { base: 'Chip.bg.selected' },
        boxShadowColor: { base: 'Chip.border.selected' },
      },
    },
    {
      disabled: false,
      selected: true,
      css: {
        backgroundColor: {
          base: 'Chip.bg.selected',
          _hover: 'Chip.bg.selectedHover',
          _active: 'Chip.bg.selectedPressed',
        },
        boxShadowColor: {
          base: 'Chip.border.selected',
          _hover: 'Chip.border.selectedHover',
          _active: 'Chip.border.selectedPressed',
        },
      },
    },
    {
      elevated: true,
      disabled: false,
      selected: false,
      css: {
        boxShadow: {
          base: 'inset 0 0 0 {borderWidths.Chip.default} var(--shadow-color), {shadows.Chip.elevated.default}',
          _hover: {
            base: 'inset 0 0 0 {borderWidths.Chip.default} var(--shadow-color), {shadows.Chip.elevated.hover}',
            _focusVisible:
              'inset 0 0 0 {borderWidths.Chip.default} var(--shadow-color), {shadows.Chip.elevated.hover}, {shadows.focus}',
          },
          _active:
            'inset 0 0 0 {borderWidths.Chip.default} var(--shadow-color), {shadows.Chip.elevated.pressed}',
          _focusVisible:
            'inset 0 0 0 {borderWidths.Chip.default} var(--shadow-color), {shadows.focus}',
        },
      },
    },
    {
      elevated: true,
      disabled: false,
      selected: true,
      css: {
        boxShadow: {
          base: 'inset 0 0 0 {borderWidths.Chip.selected} var(--shadow-color), {shadows.Chip.elevated.default}',
          _hover: {
            base: 'inset 0 0 0 {borderWidths.Chip.selected} var(--shadow-color), {shadows.Chip.elevated.hover}',
            _focusVisible:
              'inset 0 0 0 {borderWidths.Chip.selected} var(--shadow-color), {shadows.Chip.elevated.hover}, {shadows.focus}',
          },
          _active:
            'inset 0 0 0 {borderWidths.Chip.selected} var(--shadow-color), {shadows.Chip.elevated.pressed}',
          _focusVisible:
            'inset 0 0 0 {borderWidths.Chip.selected} var(--shadow-color), {shadows.focus}',
        },
      },
    },
  ],
});
